import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { Bounds } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import styled from 'styled-components';

interface Props {
  bounds: Bounds;
  border?: string;
  background?: string;
  className?: string;
}

export function LensImpactProfileBar(props: Props) {
  const { bounds } = props;
  const params = {
    fill: props.background || 'transparent',
    stroke: props.border || BouColor.IMPACT_BORDER_GRAY,
    strokeWidth: 1,
  };
  return (
    <G style={{ transform: `translate(${bounds.x1}px,${bounds.y1}px)` }}>
      <Rect
        className={props.className}
        x={0}
        y={0}
        rx={2}
        ry={2}
        {...params}
        style={{ width: bounds.width, height: bounds.height }}
      />
    </G>
  );
}

const G = styled.g`
  transition: transform 0.5s ease-in-out;
`;

const Rect = styled.rect`
  transition:
    width 0.5s ease-in-out,
    fill 0.5s ease-in-out,
    height 0.5s ease-in-out,
    border 0.15s ease-in-out;
`;
